import React from "react";
import Skeleton from "components/ui/Skeleton";
import { EMAIL_TYPE_META } from "../utils";

const SystemEmailTypeBreakdown = ({ data, loading }) => {
  const rows = [...(data || [])]
    .map((d) => {
      const meta = EMAIL_TYPE_META[d.type] || { label: d.label || d.type, color: "var(--color-text-muted)" };
      return { ...d, label: meta.label, color: meta.color };
    })
    .sort((a, b) => b.count - a.count);
  const maxCount = Math.max(1, ...rows.map((r) => r.count));

  return (
    <div className="rounded-2xl border border-border bg-surface p-5">
      <h2 className="font-semibold text-text_primary mb-4">By Email Type</h2>

      {loading ? (
        <Skeleton.Bars rows={6} />
      ) : rows.length === 0 ? (
        <p className="text-sm text-text_muted py-10 text-center">No system emails in this period</p>
      ) : (
        <div className="space-y-3.5">
          {rows.map((r) => (
            <div key={r.type}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-xs font-medium text-text_secondary">{r.label}</span>
                <span className="text-xs font-semibold text-text_primary tabular-nums">{r.count}</span>
              </div>
              <div className="w-full bg-surface_alt rounded-full h-1.5 overflow-hidden">
                <div className="h-full rounded-full" style={{ width: `${(r.count / maxCount) * 100}%`, backgroundColor: r.color }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SystemEmailTypeBreakdown;
